export enum RegionSearchTabsType {
    LOCATION,
    TRAVEL_TIME,
    DISTRICTS
}
